module.exports = __webpack_public_path__ + "static/flux-persona-2-d894319a75a1b069053d4b91dd40eab5.png";